/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the action to take after the Enter key is pressed to complete edit mode.
 */
export var EnterKeyBehaviorAfterEdit = /*@__PURE__*/ (function (EnterKeyBehaviorAfterEdit) {
    /**
     * The Enter key does nothing.
     */
    EnterKeyBehaviorAfterEdit[EnterKeyBehaviorAfterEdit["None"] = 0] = "None";
    /**
     * Moves the active cell down after the Enter key is pressed.
     */
    EnterKeyBehaviorAfterEdit[EnterKeyBehaviorAfterEdit["MoveDown"] = 1] = "MoveDown";
    /**
     * Moves the active cell to the right after the Enter key is pressed.
     */
    EnterKeyBehaviorAfterEdit[EnterKeyBehaviorAfterEdit["MoveRight"] = 2] = "MoveRight";
    /**
     * Moves the active cell up after the Enter key is pressed.
     */
    EnterKeyBehaviorAfterEdit[EnterKeyBehaviorAfterEdit["MoveUp"] = 3] = "MoveUp";
    /**
     * Moves the active cell to the left after the Enter key is pressed.
     */
    EnterKeyBehaviorAfterEdit[EnterKeyBehaviorAfterEdit["MoveLeft"] = 4] = "MoveLeft";
    return EnterKeyBehaviorAfterEdit;
})({});
/**
 * @hidden
 */
export var EnterKeyBehaviorAfterEdit_$type = /*@__PURE__*/ markEnum('EnterKeyBehaviorAfterEdit', 'None,0|MoveDown,1|MoveRight,2|MoveUp,3|MoveLeft,4');
//# sourceMappingURL=EnterKeyBehaviorAfterEdit.js.map
